module.exports = __webpack_public_path__ + "Icono_EncuestasMenu_126px.png";